import { AbortError } from "../error/index.js";

//#region ../../node_modules/@jwplayer/fe-common/module/util/promise/index.js
const PromiseUtil = {
	coalesce(fn) {
		let promise;
		return ((...args) => {
			if (promise) return promise;
			promise = fn(...args).finally(() => {
				promise = void 0;
			});
			return promise;
		});
	},
	once(fn) {
		let promise;
		return ((...args) => {
			if (promise) return promise;
			promise = fn(...args);
			return promise;
		});
	},
	extract() {
		let resolve;
		let reject;
		const promise = new Promise((res, rej) => {
			resolve = res;
			reject = rej;
		});
		return {
			promise,
			resolve: (res) => resolve(res),
			reject: (err) => reject(err)
		};
	},
	latest(fn) {
		let abortControllers = [];
		return (async (...args) => {
			for (const abortController of abortControllers) abortController.abort();
			const ctrl = new AbortController();
			abortControllers.push(ctrl);
			try {
				const ret = await fn(...args);
				if (ctrl.signal.aborted) throw new AbortError(ctrl.signal);
				return ret;
			} finally {
				abortControllers = abortControllers.filter((c) => c !== ctrl);
			}
		});
	}
};

//#endregion
export { PromiseUtil };